var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"bar-card-tab elevation-1",class:{ active: _vm.active, pointer: !!_vm.on.click && !_vm.active }},_vm.on),[_vm._t("default",function(){return [_c('span',[(_vm.icon)?_c('v-icon',{staticClass:"mx-0"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }